/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { ensureType as t } from "../ensureType.js";
import { getOwnPropertyMetadata as n } from "../metadata.js";
var o = Object.prototype.toString;

function r(n) {
  var o = "__accessorMetadata__" in n ? t(n) : n;
  return function () {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    if (t.push(o), "number" == typeof t[2]) throw new Error("Using @cast has parameter decorator is not supported since 4.16");
    return e.apply(this, t);
  };
}

function e(t, o, r, e) {
  n(t, o).cast = e;
}

function i(t) {
  return function (o, r) {
    n(o, t).cast = o[r];
  };
}

function c() {
  if (3 !== arguments.length || "string" != typeof (arguments.length <= 1 ? undefined : arguments[1])) return 1 === arguments.length && "[object Function]" === o.call(arguments.length <= 0 ? undefined : arguments[0]) ? r(arguments.length <= 0 ? undefined : arguments[0]) : 1 === arguments.length && "string" == typeof (arguments.length <= 0 ? undefined : arguments[0]) ? i(arguments.length <= 0 ? undefined : arguments[0]) : void 0;
}

export { c as cast };